<template>
    <div class="text-center custom-banner">
        <!-- <h6 class="banner-text mb-0"><a class="text-light" href="/menu/happy-hour">Check out our Happy Hour Menu!</a></h6> -->
        <!-- <h6 class="banner-text mb-0"><a class="text-light" href="/menu/thanksgiving">Checkout our Thanksgiving Menu!</a></h6> -->
         <!-- <h6 class="banner-text mb-0"><a class="text-light" href="/menu/newyears">Checkout our New Year's Day Brunch Menu!</a></h6> -->
         <!-- <h6 class="banner-text mb-0"><a class="text-light" href="/menu/newyears">Checkout our lunch additions every Saturday & Sunday from 12-3pm</a></h6> -->
        <h6 class="banner-text mb-0">
            <a class="text-light" target="_blank" href="https://www.opentable.com/booking/restref/availability?lang=en-US&correlationId=a2d231de-4f84-4421-9732-545506ffdb4d&restRef=1239994&otSource=Restaurant%20website">
                Make your reservation today!
            </a>
        </h6>
    </div>
</template>

<script>
export default {
    name: 'HeaderBanner'
}
</script>